import {ref, watch} from 'vue';

export default function usePagination(fetchData, initialRows = 10) {
    const page = ref(0);
    const rows = ref(initialRows);
    const sortField = ref(null);
    const sortOrder = ref(null);

    // Whenever page, rows, sortField, or sortOrder changes, refetch
    watch([page, rows, sortField, sortOrder], () => {
        fetchData();
    });

    function onPageChange(event) {
        page.value = event.page;
        rows.value = event.rows;
    }

    function onSortChange(event) {
        sortField.value = event.sortField;
        sortOrder.value = event.sortOrder;
        page.value = 0;
    }

    return {
        page,
        rows,
        sortField,
        sortOrder,
        onPageChange,
        onSortChange
    };
}
